module.exports = __webpack_public_path__ + "static/media/powerpoint.3a6497e9.svg";